export function initializeOnclickFilters() {
	const dataSourceSelect = document.getElementById('data-source');
	const tagSelect = document.querySelectorAll('.tag-filter');

	const url = new URL(window.location);

	if (dataSourceSelect) {

		dataSourceSelect.value = url.searchParams.get('data_source') ? url.searchParams.get('data_source') : '';

		dataSourceSelect.addEventListener('change', function () {
			const selectedValue = this.value;
			if (selectedValue) {
				// Convert spaces to underscores
				const formattedValue = selectedValue.replace(/\s+/g, '_');
				if (formattedValue === 'aragon_advertising_ringba') {
					url.searchParams.set('data_source', 'aragonadvertisingringba');
				} else {
					url.searchParams.set('data_source', formattedValue);
				}
			} else {
				// Remove the parameter if "All Sources" is selected
				url.searchParams.delete('data_source');
			}

			// Update the URL without reloading the page
			window.location.href = url.toString();
		});
	}

	if (tagSelect) {
		tagSelect.forEach(select => {
			select.addEventListener('click', function () {
				const tagSelected = this.getAttribute('data-tag-title').replace(/\s+/g, '_');
				const selectedValue = this.innerText.trim();

				if(!selectedValue || !tagSelected) {
					return;
				}

				if(url.searchParams.get("tag") === tagSelected && url.searchParams.get("tag_value") === selectedValue.replace(/\s+/g, '_')) {
					// If the same tag and value are selected, remove the filter
					url.searchParams.delete("tag");
					url.searchParams.delete("tag_value");
					window.location.href = url.toString();
					return;
				}

				// Convert spaces to underscores
				const formattedValue = selectedValue.replace(/\s+/g, '_');
				url.searchParams.set("tag", tagSelected);
				url.searchParams.set("tag_value", formattedValue);
				
				// Update the URL without reloading the page
				window.location.href = url.toString();
			});
		});
	}
}